import { useRef, useEffect, useState } from 'react';
import { icons } from '../../services/_consts';
export const ImgUploder = ({ avatar, maxSize = 952490, onChanged, onChanging, style, multiple }) => {
    const [openCam, setOpenCam] = useState(false);
    const btnStyle = {
        position: 'absolute',
        marginRight: '-24px',
        color: 'blue',
        width: '26px',
        height: '26px',
        borderRadius: '50%',
        fontSize: '20px',
        filter: 'drop-shadow(0px 0px 4px yellow)'
    };
    const avatarInput = useRef(null);
    const style1 = { width: '60px', height: '60px', overflow: 'hidden', display: 'inline-flex', borderRadius: '50%', border: '1px solid' };
    if (style) {
        if (!style.display) style.display = 'inline-flex';
        if (!style.overflow) style.overflow = 'hidden';
        //if (!style.cursor) style.cursor = 'pointer';
        if (!style.position) style.position = 'relative';
    }

    const onChangeing = (e) => {
        if (e.target.files[0].size > maxSize) {
            debugger
            alert("max file size " + maxSize + "");
            return;
        }
        var reader = new FileReader();
        var url = reader.readAsDataURL(e.target.files[0]);

        if (onChanging)
            onChanging(e.target.files);

        reader.onloadend = function (e) {
            onChanged([reader.result]);

            // this.setState({ avatar: [reader.result] });
            // this.props.handleChange('avatar', [reader.result]);
        }.bind(this);
    }

    const openFileChooser = () => avatarInput.current.click();

    const removeImg = () => {
        avatarInput.value = null;
        onChanged(null);
    }

    let stream;
    let video;
    const openCamera =  () => {
        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
            setOpenCam(true);
        }
    }
    useEffect( () => {
        if (openCam) {
            video = document.querySelector("#video");
            navigator.mediaDevices.getUserMedia({ video: true, audio: false }).then(x => {
                stream = x;
                video.srcObject = stream;
            });
        }
        else {

        }
    }, [openCam]);

    const capture = () => {
        let canvas = document.querySelector("#canvas");
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        let image_data_url = canvas.toDataURL('image/jpeg');

        //avatar = image_data_url;

        closeModal();

        if (onChanged)
            onChanged(image_data_url);
      
    }

    const closeModal=() => {
        setOpenCam(false);
        stream?.getTracks().forEach(function (track) { track.stop(); });
    }

    return <div className="imageUploader" style={{ position: 'relative', display: 'inline-flex' }}>
        <input type="file" onChange={e => onChangeing(e)} ref={avatarInput} style={{ display: 'none' }} multiple={multiple} />
        <div style={style || style1} >
            {avatar ?
                <img src={avatar}
                    style={{ width: '100%', height: 'fit-content' }} /> :
                <i className={icons.user + ' text-center'}
                    style={{ width: '100%', fontSize: '50px', paddingTop: '10px', color: 'gray' }}></i>
            }
        </div>
        {avatar && <>
            <button onClick={removeImg} className='btn p-0 noPrint' style={{
                ...btnStyle, top: '-6px', color: 'red'
            }}><i className='las la-trash bg-white'></i></button>
        </>}
        {/*<button onClick={openCamera} className="btn p-0 noPrint"
                   style={{ ...btnStyle, top: '21px', }}><i className="las la-camera bg-white"></i></button>*/}


        <button onClick={openFileChooser} className="btn p-0 noPrint"
            style={{ ...btnStyle, top: '48px', }} ><i className="las la-image bg-white"></i></button>


        {/* camera dialog */}
        {openCam &&
            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block", backdropFilter: 'blur(5px)', background: '#bdbdbd96' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                            <button type="button" className="btn-close p-3" onClick={closeModal}></button>

                        <div className="modal-body text-center">
                            
                            <video id="video" style={{ marginTop:-140 }} width="692" height="707" autoPlay />
                            <br />
                            <button onClick={capture} style={{  }} className="rounded btn btn-outline-primary ">
                                <i className="las la-camera la-2x"></i>
                            </button>
                            <canvas className="d-none" id="canvas" width="692" height="707"></canvas>
                        </div>
                    </div>
                </div>
            </div>}
    </div>
}